import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";

const LeaveEncashmentBreakdown = ({ isOpen, onClose, employee }) => {
  const [currentPage, setCurrentPage] = useState(1);

  if (!isOpen || !employee) return null;

  const headers = ["Type", "Balance", "Encashable", "Non-Tax", "Taxable", "Total Value"];
  const accessors = ["leaveType", "balance", "encashable", "nonTax", "taxable", "totalValue"];

  const customRender = (row, accessor) => {
    const opacity = !row.isEncashable ? "opacity-30 grayscale" : "";

    if (accessor === "leaveType") return <span className={`font-bold ${opacity}`}>{row[accessor]}</span>;
    if (accessor === "balance") return <span className={opacity}>{row[accessor]}</span>;
    if (accessor === "encashable") return <span className={`font-bold text-blue-700 ${opacity}`}>{row[accessor]} Days</span>;
    
    // // MODIFIED: Mixing Amount and Day Count for Non-Tax
    if (accessor === "nonTax") return (
      <div className={`flex flex-col text-right ${opacity}`}>
        <span className="text-green-600 font-bold">₱{row[accessor].toLocaleString()}</span>
        <span className="text-[10px] text-gray-400 font-medium">({row.nonTaxableDays} Days)</span>
      </div>
    );

    // // MODIFIED: Mixing Amount and Day Count for Taxable
    if (accessor === "taxable") return (
      <div className={`flex flex-col text-right ${opacity}`}>
        <span className="text-orange-600 font-bold">₱{row[accessor].toLocaleString()}</span>
        <span className="text-[10px] text-gray-400 font-medium">({row.taxableDays} Days)</span>
      </div>
    );

    if (accessor === "totalValue") return <span className={`font-extrabold text-blue-900 ${opacity}`}>₱{row[accessor].toLocaleString()}</span>;
    
    return null;
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto" style={{ marginTop: 0 }}>
      <div className="bg-gray-50 w-full md:w-[95%] lg:w-[85%] rounded-lg shadow-xl h-auto max-h-[90vh] flex flex-col relative">
        
        <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 bg-white rounded-t-lg">
          <div className="flex flex-col">
            <h2 className="text-xl font-semibold text-gray-500 tracking-tight">Encashment Breakdown</h2>
            <span className="text-sm text-blue-800 font-bold">{employee.fullName} ({employee.employeeId})</span>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 bg-transparent border-none cursor-pointer">
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto">
          <CreateTable
            tableName="EncashmentBreakdownTable"
            headers={headers}
            accessors={accessors}
            data={employee.leaveDetails || []}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={10}
            totalItems={employee.leaveDetails?.length || 0}
            customCellRenderer={customRender}
          />
        </div>

        <div className="flex justify-end p-4 border-t bg-white rounded-b-lg">
          <button onClick={onClose} className="bg-gray-500 hover:bg-gray-600 text-white px-6 py-2 rounded cursor-pointer border-none transition-colors">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveEncashmentBreakdown;